module.exports = __webpack_public_path__ + "92f27d344b9ca4bce7fd7084c685031a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/icons/ic_notification.svg
// module id = 1622
// module chunks = 1